import { _ } from "src/services";

export const ProfilePackageBoxShimmer: React.FC = () => {

    return (
        <div className="profile-package">
            <div className="d-flex flex-column flex-md-row justify-content-start">
                <div className="d-flex align-items-center">
                    <div className="package-logo shimmer" />
                    <span className="package-title shimmer"></span>
                </div>
                <div className="flex-1"></div>
                <div className="d-flex align-items-center justify-content-between">
                    <span className="package-status text-center shimmer"></span>
                    <span className="btn btn-packages disabled">{_("renew")}</span>
                </div>
            </div>
        </div>

    );

};